// extracted by mini-css-extract-plugin
export default {"link":"custom-link_link__QNb9T","lin":"custom-link_lin__4ATnA"};